import * as yup from 'yup';

export const loginSchema = yup.object({
    email: yup.string().required('Ce champ est obligatoire et doit être rempli.')
        .email('L\'adresse email saisie est invalide.'),
    password: yup.string().required('Ce champ est obligatoire et doit être rempli.'),
});